import { render, staticRenderFns } from "./CampaignMemberRedemptionHistoryBody.vue?vue&type=template&id=bfd29e36"
import script from "./CampaignMemberRedemptionHistoryBody.vue?vue&type=script&lang=js"
export * from "./CampaignMemberRedemptionHistoryBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports